/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { AppWrap, MotionWrap } from '../../wrapper';
import { skills as skillsData } from '../../data/portfolio';
import './Skills.scss';

// Import icons from react-icons
import {
  SiReact,
  SiTypescript,
  SiNodedotjs,
  SiPython,
  SiFastapi,
  SiAmazonaws,
  SiDocker,
  SiMongodb,
  SiPostgresql,
  SiGraphql,
  SiHtml5,
  SiGithubactions,
  SiJest,
  SiGithub,
  SiJava,
  SiOpenai,
  SiSupabase
} from 'react-icons/si';
import { GiBrain, GiChainLightning } from 'react-icons/gi';
import { AiOutlineCluster } from 'react-icons/ai';
import { MdArchitecture } from 'react-icons/md';
import { FaLayerGroup, FaCodeBranch } from 'react-icons/fa';

// Icon mapping
const iconMap = {
  SiReact,
  SiTypescript,
  SiNodedotjs,
  SiPython,
  SiFastapi,
  GiBrain,
  SiOpenai,
  SiAmazonaws,
  GiChainLightning, // LangChain uses chain lightning icon as alternative
  SiDocker,
  SiMongodb,
  SiPostgresql,
  SiGraphql,
  AiOutlineCluster,
  MdArchitecture,
  FaLayerGroup,
  SiHtml5,
  SiGithubactions,
  SiJest,
  SiGithub,
  FaCodeBranch,
  SiJava,
  SiSupabase
};

const Skills = () => {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    setSkills(skillsData);
  }, []);

  return (
    <>
      <h2 className="head-text">Tech</h2>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill) => {
            const IconComponent = iconMap[skill.icon];
            return (
              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5 }}
                className="app__skills-item app__flex"
                key={skill.name}
              >
                <div className="app__flex app__skills-icon">
                  {IconComponent && <IconComponent size={50} />}
                </div>
                <p className="p-text">{skill.name}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'tech',
  'app__whitebg',
);
